import { ControlIcons } from 'owa-control-icons';
import { myDay } from './getMyDayListData.locstring.json';
import loc from 'owa-localize';

export function getMyDayListData(): { text: string; icon: string } {
    return {
        text: loc(myDay),
        icon: ControlIcons.Sunny,
    };
}
